var _rect, _path, _path2, _circle, _circle2, _circle3, _circle4, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUpdateTripIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 110,
    height: 110,
    viewBox: "0 0 110 110",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 109,
    height: 109,
    rx: 11.5,
    fill: "#F8FBFF",
    stroke: "#EBF1FA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.7222 52.8504H45.7871C45.5882 52.8143 45.1037 52.8504 44.7566 53.2843L42.262 57.5144C42.2077 57.6229 42.0993 57.9157 42.0993 58.2194V62.3953C42.0993 62.6122 42.262 63.0786 42.9128 63.2088H63.4667C63.8825 63.2449 64.6815 63.0678 64.5514 62.0699V59.6295H50.7222V52.8504ZM49.2719 54.5758V57.9925H44.4452L46.3433 54.5758H49.2719Z",
    fill: "#F2453D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M64.2756 50.673V51.4323H68.6684C69.4059 51.4323 69.4818 51.8299 69.4276 52.0288C69.5578 52.7663 68.9757 53.023 68.6684 53.0592H64.2756V54.9573H66.9872C67.6813 55.0007 67.7826 55.3731 67.7464 55.5539C67.9633 56.1613 67.3306 56.5662 66.9872 56.6927H64.2756V58.4282H65.3602C66.2279 58.9054 65.9387 59.6032 65.6856 59.8924H50.5548V50.673C50.5982 49.6318 51.5129 49.6246 51.9648 49.7511H63.1909C64.0586 49.7945 64.2756 50.3838 64.2756 50.673Z",
    fill: "#FEC02F"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 2.49468,
    cy: 2.49468,
    r: 2.49468,
    transform: "matrix(-1 0 0 1 49.814 59.8867)",
    fill: "#465A64"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 0.813483,
    cy: 0.813483,
    r: 0.813483,
    transform: "matrix(-1 0 0 1 48.0785 61.6211)",
    fill: "white"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 2.49468,
    cy: 2.49468,
    r: 2.49468,
    transform: "matrix(-1 0 0 1 61.7458 59.8867)",
    fill: "#465A64"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 0.813483,
    cy: 0.813483,
    r: 0.813483,
    transform: "matrix(-1 0 0 1 60.0104 61.6211)",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.1738 77.5801L56.0339 75.2985C55.9824 74.4583 54.9793 74.0538 54.3594 74.6232L49.3863 79.1904C48.9185 79.62 48.9646 80.3713 49.4814 80.7405L54.9751 84.6661C55.6599 85.1555 56.6061 84.6314 56.5546 83.7913L56.4505 82.0943C56.5283 82.0992 56.6073 82.0998 56.6874 82.0959C61.8101 81.8465 66.7752 80.1502 70.9958 77.1809C75.85 73.7657 79.4521 68.8545 81.251 63.1984C83.0499 57.5423 82.9467 51.4527 80.9571 45.8608C79.2273 40.999 76.1543 36.7461 72.1168 33.5834C71.1093 32.7942 69.666 33.1021 68.9656 34.1731C68.2651 35.2441 68.5745 36.6713 69.5679 37.478C72.7645 40.0738 75.2007 43.5069 76.591 47.4143C78.2411 52.0521 78.3267 57.1027 76.8347 61.7938C75.3427 66.4849 72.3552 70.5582 68.3292 73.3907C64.9372 75.777 60.9654 77.172 56.8567 77.4444C56.6204 77.46 56.3911 77.5065 56.1738 77.5801Z",
    fill: "#2FD58B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.3569 32.2772L54.4972 34.5561C54.5489 35.3962 55.5521 35.8005 56.1719 35.231L61.1438 30.6624C61.6115 30.2327 61.5652 29.4814 61.0483 29.1123L55.5536 25.1882C54.8686 24.699 53.9226 25.2232 53.9743 26.0634L54.079 27.7631C54.0012 27.7582 53.9221 27.7576 53.842 27.7616C48.7193 28.0122 43.7546 29.7098 39.5348 32.6802C34.6814 36.0967 31.0807 41.0088 29.2832 46.6654C27.4857 52.3219 27.5905 58.4116 29.5816 64.0029C31.3126 68.8643 34.3867 73.1163 38.4251 76.2781C39.4327 77.067 40.876 76.7587 41.5761 75.6875C42.2763 74.6163 41.9665 73.1892 40.9729 72.3827C37.7757 69.7877 35.3386 66.3553 33.9473 62.4483C32.296 57.8109 32.2091 52.7603 33.6999 48.0688C35.1907 43.3774 38.1771 39.3033 42.2024 36.4698C45.5937 34.0825 49.5652 32.6865 53.6739 32.4131C53.9101 32.3974 54.1396 32.3508 54.3569 32.2772Z",
    fill: "#2FD58B"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M50.2671 49.6622L55.13 55.5458L67.8953 43.4844",
    stroke: "#1FD885",
    strokeWidth: 4
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpdateTripIcon);
export default __webpack_public_path__ + "static/media/update-trip-icon.ea287a0c757797efdc4f9da7d74b09cd.svg";
export { ForwardRef as ReactComponent };